import React, { Component } from 'react'
import { Dropdown } from 'antd'

// recieves interaction pings from iframes
// and hides itself, if open
class DropdownBlurrable extends Component {
  state = {
    visible: false,
  }

  componentDidMount() {
    window.addEventListener('message', this.handleMessage, false)
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage, false)
  }

  handleMessage = (e) => {
    const { visible } = this.state
    if ((e.data.type === 'IN_IFRAME_CLICK') && visible) {
      this.setState({
        visible: false,
      })
    }
  }

  handleVisibleChange = (visible) => {
    this.setState({
      visible,
    })
  }

  handleClick = () => {
    const { visible } = this.state
    if (visible) {
      this.setState({
        visible: false,
      })
    }
  }

  render() {
    const { visible } = this.state
    return (
      <div onClick={this.handleClick}>
        <Dropdown
          {...this.props}
          visible={visible}
          onVisibleChange={this.handleVisibleChange}
        />
      </div>
    )
  }
}

export default DropdownBlurrable
